export default __webpack_public_path__ + "static/media/AnimalsRed_04.289713a4.png";